function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.9185 12.3201C15.6595 12.5711 15.5405 12.9341 15.5995 13.2901L16.4885 18.2101C16.5635 18.6271 16.3875 19.0491 16.0385 19.2901C15.6965 19.5401 15.2415 19.5701 14.8685 19.3701L10.4395 17.0601C10.2855 16.9781 10.1145 16.9341 9.93949 16.9291H9.66849C9.57449 16.9431 9.48249 16.9731 9.39849 17.0191L4.96849 19.3401C4.74949 19.4501 4.50149 19.4891 4.25849 19.4501C3.66649 19.3381 3.27149 18.7741 3.36849 18.1791L4.25849 13.2591C4.31749 12.9001 4.19849 12.5351 3.93949 12.2801L0.328494 8.7801C0.0264944 8.4871 -0.0785057 8.0471 0.0594943 7.6501C0.193494 7.2541 0.535494 6.9651 0.948494 6.9001L5.91849 6.1791C6.29649 6.1401 6.62849 5.9101 6.79849 5.5701L8.98849 1.0801C9.04049 0.980099 9.10749 0.888099 9.18849 0.810099L9.27849 0.740099C9.32549 0.688099 9.37949 0.645099 9.43949 0.610099L9.54849 0.570099L9.71849 0.500099H10.1395C10.5155 0.539099 10.8465 0.764099 11.0195 1.1001L13.2385 5.5701C13.3985 5.8971 13.7095 6.1241 14.0685 6.1791L19.0385 6.9001C19.4585 6.9601 19.8095 7.2501 19.9485 7.6501C20.0795 8.0511 19.9665 8.4911 19.6585 8.7801L15.9185 12.3201Z",
  fill: "#C2C9D1"
});

function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3eeea315.svg";
export { ForwardRef as ReactComponent };